import "./Staff.scoped.scss";

export default function Staff() {
  return (
    <div className="root mt-24">
      <div className="title text-center">Staff</div>
      <hr />
      <div className="staff">
        <ul>
          <li className="exective">主催</li>
          <li>のらキウイ</li>
        </ul>
        <ul>
          <li className="exective">サイトデザイン</li>
          <li>Blank</li>
        </ul>
        <ul>
          <li className="exective">アイコン</li>
          <li>
            おフランス製
            <br />
            (Twitterアイコン/
            <br />
            Decotter)
          </li>
          <li>
            Blank
            <br />
            （favicon）
          </li>
        </ul>
        <ul>
          <li className="exective">コーディング</li>
          <li>バイザン</li>
          <li>トコロテン</li>
          <li>ややや</li>
        </ul>
        <ul>
          <li className="exective">イラスト</li>
          <li>
            ねこわさ
            <br />
            （集合イラスト監督）
          </li>
          <li>
            いあぐ
            <br />
            （ポラロイド枠等）
          </li>
        </ul>
        <ul>
          <li className="exective">クイズ</li>
          <li>さつき野（作問）</li>
          <li>るーしえ（作問）</li>
          <li>
            mikka
            <br />
            (TOP絵/
            <br />
            Twitterカード)
          </li>
        </ul>
        <ul>
          <li className="exective">メッセージ</li>
          <li>Blank（TOP絵）</li>
          <li>mikka（台紙）</li>
          <li>ゆや</li>
          <li>鯉太朗</li>
          <li>あっきー2号</li>
        </ul>
        <ul>
          <li className="exective">きせかえ</li>
          <li>七尾狐（監督）</li>
          <li>
            KΔNON
            <br />
            (学生服/メイド/
            <br />
            白タートルネック)
          </li>
          <li>
            ローリエ
            <br />
            (夏服/黒シャツ)
          </li>
          <li>
            白井すい
            <br />
            （振り袖）
          </li>
          <li>
            百合原
            <br />
            （王冠/ねこピン）
          </li>
        </ul>
        <ul>
          <li className="exective">いろいろ</li>
          <li>えくれあ</li>
          <li>ぞえ</li>
          <li>あまざけ</li>
        </ul>
      </div>
    </div>
  );
}
